module.exports = __webpack_public_path__ + "static/media/ag.cce32c73.svg";